import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ReportAPI } from '../../../api'
import { ConvertLocalTimeGet } from '../../../utils'
import { SET_USER_PROFILE_LOCATION } from '../../../redux/actions'

const useHooks = () => {
  const dispatch = useDispatch()

  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  const [filter, setFilter] = useState({
    date: new Date()
  })

  const [total, setTotal] = useState(0)
  const [pending, setPending] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [dailyProduction, setDailyProduction] = useState([])

  const onLocationChange = (event) => {
    setFilter({
      ...filter,
      location: event.value
    })
  }

  const onDateChange = (event) => {
    setFilter({
      ...filter,
      date: event.value
    })
  }

  const setLocation = (value) => {
    const valueLocation = UserLocations.find(
      (e) => e.LocationDescription === value
    )

    dispatch({
      type: SET_USER_PROFILE_LOCATION,
      payload: valueLocation
    })
  }

  const generateColumns = (columns) => {
    const cols = columns?.map((col) => {
      if (col.field === 'daily_production') {
        return {
          ...col,
          title: `Daily Production (${moment(filter.date)
            .subtract(1, 'days')
            .format('DD')}-${moment(filter.date).format('DD MMM YYYY')})`,
          customCell: col.customCell || null
        }
      }
      return { ...col }
    })
    return cols
  }

  const reconstructData = (data) =>
    data?.map((item) => {
      const formatDate = (val, format = 'DD MMM YYYY') =>
        val
          ? ConvertLocalTimeGet(Location.LocationDescription, val, format)
          : null

      return {
        ...item,
        departure: formatDate(item.departure, 'DD MMM YYYY HH:mm'),
        eta: formatDate(item.eta, 'DD MMM YYYY HH:mm'),
        arrival: formatDate(item.arrival, 'DD MMM YYYY HH:mm'),
        laycan_start: formatDate(item.laycan_start),
        form: formatDate(item.form),
        laycan_end: formatDate(item.laycan_end),
        to: formatDate(item.to),
        commence_loading_date: formatDate(item.commence_loading_date, 'DD MMM YYYY HH:mm'),
      }
    }) || []

  const downloadBase64Excel = (base64, fileName = 'report.xlsx') => {
    const byteCharacters = atob(base64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  const exportData = async ({ location, filterPeriod }) => {
    try {
      setIsExporting(true)
      const filters = JSON.stringify([{ field: 'location', value: location }])
      const { data } = await ReportAPI.ExportExcelDailyProduction(
        filters,
        filterPeriod
      )
      if (data) {
        downloadBase64Excel(data, `daily-production-${filterPeriod}.xlsx`)
      }
      setIsExporting(false)
    } catch (error) {
      setIsExporting(false)
      console.log(error)
    } finally {
      setIsExporting(false)
    }
  }

  const fetchData = async ({ location, filterPeriod }) => {
    try {
      setPending(true)
      const filters = JSON.stringify([{ field: 'location', value: location }])
      const { data } = await ReportAPI.GetDailyProduction(filters, filterPeriod)

      const reconstructedData = reconstructData(data)
      setDailyProduction(reconstructedData)
      setPending(false)
    } catch (error) {
      setPending(false)
      console.log(error)
    } finally {
      setPending(false)
    }
  }

  useEffect(() => {
    generateColumns()
  }, [filter.date])

  useEffect(() => {
    fetchData({
      location: String(Location?.LocationID),
      filterPeriod: moment(filter.date).format('YYYY-MM-DD')
    })
  }, [Location, filter.date])

  return {
    data: {
      total,
      filter,
      pending,
      Location,
      isExporting,
      UserLocations,
      dailyProduction
    },
    methods: {
      setTotal,
      setPending,
      exportData,
      setLocation,
      onDateChange,
      generateColumns,
      onLocationChange
    }
  }
}

export default useHooks
